import { Moon, Sun } from "lucide-react";
import UserActions from "./UserActions";
import LanguageSwitcher from "./LanguageSwitcher";
import { Switch } from "@/components/ui/switch";
import { useTheme } from "@/context/ThemeContext";
import { useAuth } from "@/hooks/useAuth";

/**
 * Capacitor app header: user actions; chat lives in bottom nav.
 */
const MobileAppHeader = () => {
  const { user } = useAuth();
  const { theme, toggleTheme } = useTheme();
  const isDark = theme === "dark";

  return (
    <header
      className={`native-app-header fixed z-50 overflow-x-hidden ${
        isDark
          ? "bg-black/85 border-b border-white/10"
          : "bg-white/95 border-b border-gray-200"
      }`}
    >
      <div className="max-w-5xl mx-auto px-3 sm:px-4">
        <div className="flex items-center justify-end min-w-0 gap-1 w-full native-header-row">
            {!user && (
              <>
                <LanguageSwitcher dropdownAlign="end" />
                <div className="flex items-center gap-1 px-0.5">
                  {isDark ? (
                    <Moon className="h-4 w-4 text-accent shrink-0" />
                  ) : (
                    <Sun className="h-4 w-4 text-accent shrink-0" />
                  )}
                  <Switch
                    checked={isDark}
                    onCheckedChange={toggleTheme}
                    className="shrink-0"
                  />
                </div>
              </>
            )}
            <UserActions />
        </div>
      </div>
    </header>
  );
};

export default MobileAppHeader;
